<template>
  <div v-loading="isLoading">
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <template slot="controls">
        <rest-form-item
          v-show="
            !autoFetchAttributes &&
              (!model.params.mapping || model.params.mapping.length < 1)
          "
          prop="params.mapping"
        />

        <el-button
          v-if="!autoFetchAttributes"
          @click="getSchema"
          icon="el-icon-refresh-right"
        >
          {{ $t('Integrations_Shopify_Button_FetchShopifyAttributes') }}
        </el-button>
      </template>

      <rest-form-item
        :label="$t('Integrations_Shopify_Field_Access_Token')"
        prop="params.access_token"
      >
        <el-input
          v-model="model.params.access_token"
          :placeholder="
            $t('Integrations_Shopify_Field_Access_Token_Placeholder')
          "
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Shopify_Field_Api_Key')"
        prop="params.api_key"
      >
        <el-input
          v-model="model.params.api_key"
          :placeholder="$t('Integrations_Shopify_Field_Api_Key_Placeholder')"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Shopify_Field_Api_Secret_Key')"
        prop="params.api_secret_key"
      >
        <el-input
          v-model="model.params.api_secret_key"
          :placeholder="
            $t('Integrations_Shopify_Field_Api_Secret_Key_Placeholder')
          "
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Shopify_Field_StoreUrl')"
        prop="params.storefront_url"
      >
        <el-input
          v-model="model.params.storefront_url"
          :placeholder="$t('Integrations_Shopify_Field_StoreUrl_Placeholder')"
        />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
export default {
  name: 'ConnectionStep',
  components: { RestFormItem, FormSection },
  props: {
    model: {
      type: Object
    },

    autoFetchAttributes: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$set(this.model, 'fixedMappings', this.fixedMappings)
    if (this.autoFetchAttributes) {
      this.getSchema()
    }
  },
  data() {
    return {
      isLoading: false,
      fixedMappings: {
        firstName: 'shopify_first_name',
        lastName: 'shopify_last_name',
        addresses: 'shopify_addresses',
        createdAt: 'shopify_created_at',
        defaultAddress: 'shopify_default_address',
        displayName: 'shopify_display_name',
        hasTimelineComment: 'shopify_has_timeline_comment',
        canDelete: 'shopify_can_delete',
        lifetimeDuration: 'shopify_lifetime_duration',
        locale: 'shopify_locale',
        note: 'shopify_note',
        numberOfOrders: 'shopify_orders_count',
        lastOrder: 'shopify_last_order',
        state: 'shopify_state',
        tags: 'shopify_tags',
        taxExempt: 'shopify_tax_exempt',
        taxExemptions: 'shopify_tax_exemptions',
        amountSpent: 'shopify_amount_spent',
        updatedAt: 'shopify_updated_at',
        validEmailAddress: 'shopify_valid_email_address',
        verifiedEmail: 'shopify_verified_email'
      }
    }
  },
  methods: {
    getSchema() {
      this.isLoading = true
      this.$set(this.model.params, 'mapping', [])
      RestApi(
        projectEndpoint({
          method: 'get',
          url: 'integrations/shopify/preview'
        })
      )
        .then(({ data }) => {
          this.model.params.mapping = data.columns
          this.updateCols()
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },

    updateCols() {
      const attrs = []
      const filterableAttributes = [
        'user_id',
        'email',
        'mobile_number',
        'whatsapp_number',
        'language',
        'timezone',
        'email_addressable',
        'email_subscription',
        'sms_addressable',
        'sms_subscription'
      ]
      this.model.params.mapping.forEach(col => {
        if (
          attrs.findIndex(
            e => e.name.toUpperCase() === col.name.toUpperCase()
          ) >= 0
        ) {
          let attrName = attrs.find(
            e => e.name.toUpperCase() === col.name.toUpperCase()
          ).name
          if (!this.isEdit) {
            this.$set(col, 'attribute', attrName)
          }
        }
        if (this.fixedMappings.hasOwnProperty(col.name)) {
          this.$set(col, 'attribute', this.fixedMappings[col.name])
        }
        if (col.name === 'legacyResourceId') {
          this.$set(col, 'attribute', 'user_id')
        }
        if (col.name === 'emailMarketingConsent') {
          this.$set(col, 'attribute', 'email_subscription')
        }
        if (
          filterableAttributes.findIndex(
            e => e.toUpperCase() === col.name.toUpperCase()
          ) >= 0
        ) {
          let attrName = filterableAttributes.find(
            e => e.toUpperCase() === col.name.toUpperCase()
          )
          if (!this.isEdit) {
            this.$set(col, 'attribute', attrName)
          }
        }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/shopify/ConnectionStep.vue